/* @flow */

import { useQuery, type QueryResult } from 'react-query';

import { client as clientApi } from 'platform/api';

import useClientId from 'common/hooks/useClientId';

export const useMinimalClient = (): QueryResult<$FixMe> => {
    const clientId = useClientId();

    return useQuery({
        queryKey: ['client', clientId, 'minimal'],
        queryFn: async () => {
            const data = await clientApi.fetch({ clientId });
            return data;
        }
    });
};
